import { HeaderTestIds } from '@trello/webdriverio-tests';
import React, { lazy, Suspense, FunctionComponent, useCallback } from 'react';
import { IconName } from 'app/common/components/controls/icon';
import { Noun, Verb, trackUe } from '@trello/analytics';
import HeaderButton from './button';
import { usePopover, Popover, PopoverScreen } from '@trello/nachos';
import { forNamespace } from 'app/common/lib/util/i18n';
import { CreateTeamPopover } from '../popovers/create-team';
import { TeamType } from '../../modules/state/models/teams';

const viewTitle = forNamespace('view title');

const HeaderCreateMenuPopoverPromise = import(
  /* webpackChunkName: "create-menu-popover" */ 'app/gamma/src/components/popovers/header-create-menu'
);
const HeaderCreateMenuPopover = lazy(() => HeaderCreateMenuPopoverPromise);

enum Screen {
  Menu,
  CreateEnterpriseTeam,
}

export const CreateMenuButton: FunctionComponent = () => {
  const { triggerRef, toggle, hide, popoverProps, push } = usePopover<
    HTMLButtonElement
  >({
    initialScreen: Screen.Menu,
  });

  const onClick = useCallback(() => {
    trackUe({
      category: Noun.HEADER,
      verb: Verb.OPENS,
      directObj: Noun.ADD_MENU,
      method: 'by clicking header add menu button',
    });
    toggle();
  }, [toggle]);

  return (
    <>
      <HeaderButton
        icon={IconName.Add}
        onClick={onClick}
        ref={triggerRef}
        testId={HeaderTestIds.CreateMenuButton}
      />
      <Popover
        {...popoverProps}
        title={viewTitle('create')}
        testId={HeaderTestIds.CreateMenuPopover}
      >
        <PopoverScreen id={Screen.Menu} noHorizontalPadding>
          <Suspense fallback={null}>
            <HeaderCreateMenuPopover
              onClickCreateEnterpriseTeam={() =>
                push(Screen.CreateEnterpriseTeam)
              }
              onCreateTeamOverlayShown={() => hide()}
              onCreateBoardOverlayShown={() => hide()}
            />
          </Suspense>
        </PopoverScreen>
        <PopoverScreen
          id={Screen.CreateEnterpriseTeam}
          title={viewTitle('create organization')}
        >
          <CreateTeamPopover teamType={TeamType.Enterprise} />
        </PopoverScreen>
      </Popover>
    </>
  );
};
